import { nftBurnMainnetAddress, nftBurnRinkebyAddress } from '../configs';



export default function getNftBurnAddress(chainNumber) {
  if (chainNumber === 1)
    return nftBurnMainnetAddress;
  if (chainNumber === 4)
    return nftBurnRinkebyAddress;
  return null;
}
